import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/dispatch-policy.ts
const spaceDispatchPolicyModeSchema = z$1.enum(["mention_only", "listen_all"]);
const spaceDispatchPolicySchema = z$1.strictObject({ mode: spaceDispatchPolicyModeSchema });
//#endregion
export { spaceDispatchPolicyModeSchema, spaceDispatchPolicySchema };

//# sourceMappingURL=dispatch-policy.js.map